import { AlternativePath } from './path';

type HreflangCluster = {
  de: string;
  ch: string;
  fr: string | null;
};

// The commercial clusters are kept in sync manually with CH_STATIC_LINKS in
// backend/app/landingpages/src/staticLinks.ts (12 of them, homepage excluded there) -
// that list can't be imported here since app-layer code must not be a domain-layer dependency.

const HREFLANG_CLUSTERS: Array<HreflangCluster> = [
  { de: '', ch: '', fr: '' },
  {
    de: 'mietwagen-mallorca.html',
    ch: 'mietwagen-mallorca.html',
    fr: 'louer-majorque.html',
  },
  {
    de: 'transporter-mieten-zuerich.html',
    ch: 'transporter-mieten-zuerich.html',
    fr: null,
  },
  {
    de: 'mietwagen-zuerich.html',
    ch: 'mietwagen-zuerich.html',
    fr: 'louer-zurich.html',
  },
  {
    de: 'mietwagen-schweiz.html',
    ch: 'mietwagen-schweiz.html',
    fr: 'louer-suisse.html',
  },
  { de: 'mietwagen-usa.html', ch: 'mietwagen-usa.html', fr: 'louer-usa.html' },
  {
    de: 'mietwagen-madeira.html',
    ch: 'mietwagen-madeira.html',
    fr: 'louer-madere.html',
  },
  {
    de: 'mietwagen-sardinien.html',
    ch: 'mietwagen-sardinien.html',
    fr: 'louer-sardaigne.html',
  },
  {
    de: 'mietwagen-island.html',
    ch: 'mietwagen-island.html',
    fr: 'louer-islande.html',
  },
  {
    de: 'mietwagen-flughafen-palma-de-mallorca.html',
    ch: 'mietwagen-flughafen-palma-de-mallorca.html',
    fr: 'louer-aeroport-majorque.html',
  },
  {
    de: 'mietwagen-malaga.html',
    ch: 'mietwagen-malaga.html',
    fr: 'louer-malaga.html',
  },
  {
    de: 'mietwagen-kreta.html',
    ch: 'mietwagen-kreta.html',
    fr: 'louer-crete.html',
  },
  {
    de: 'mietwagen-basel.html',
    ch: 'mietwagen-basel.html',
    fr: 'louer-bale.html',
  },
  {
    de: 'rechtliches/impressum.html',
    ch: 'rechtliches/impressum.html',
    fr: 'infos-legales/mentions-legales.html',
  },
  {
    de: 'rechtliches/datenschutz.html',
    ch: 'rechtliches/datenschutz.html',
    fr: 'infos-legales/confidentialite.html',
  },
  {
    de: 'rechtliches/allgemeine-geschaeftsbedingungen.html',
    ch: 'rechtliches/allgemeine-geschaeftsbedingungen.html',
    fr: 'infos-legales/conditions-generales.html',
  },
  {
    de: 'rechtliches/anbieter-ranking-bewertung.html',
    ch: 'rechtliches/anbieter-ranking-bewertung.html',
    fr: 'infos-legales/fournisseur-classement-evaluation.html',
  },
  {
    de: 'rechtliches/bildquellen.html',
    ch: 'rechtliches/bildquellen.html',
    fr: 'infos-legales/credits-photos.html',
  },
  {
    de: 'rechtliches/mein-konto-bedingungen.html',
    ch: 'rechtliches/mein-konto-bedingungen.html',
    fr: 'infos-legales/conditions-mon-compte.html',
  },
  {
    de: 'rechtliches/gutscheinbedingungen.html',
    ch: 'rechtliches/gutscheinbedingungen.html',
    fr: null,
  },
];

// Homepage landing URLs arrive as e.g. "index.html" (or a locale-suffixed
// variant); alternativePaths.ts normalizes those the same way for its output.
const normalizePath = (path: string) => (path.startsWith('index.') ? '' : path);

const resolveClusterAlternatives = (
  currentPath: string,
): Array<AlternativePath> | undefined => {
  const normalizedPath = normalizePath(currentPath);
  const cluster = HREFLANG_CLUSTERS.find(
    ({ de, ch, fr }) =>
      de === normalizedPath || ch === normalizedPath || fr === normalizedPath,
  );

  if (!cluster) {
    return undefined;
  }

  return [
    { locale: 'de', path: cluster.de },
    { locale: 'de-CH', path: cluster.ch },
    ...(cluster.fr !== null
      ? [{ locale: 'fr' as const, path: cluster.fr }]
      : []),
  ];
};

export { resolveClusterAlternatives };
